const productCategory = [
    { id: 1 , label: "Portrait Art", value: "portrait"},//
    { id: 2 , label: "Mandala Art", value: "mandala"},//
    { id: 3 , label: "Landscape Art", value: "landscape"},//
    { id: 4 , label: "Digital Art", value: "digital"},//
    { id: 5 , label: "Comic Art", value: "comic"},//
    { id: 6 , label: "Statue Art", value: "statue"},//
    { id: 7 , label: "Zen Art", value: "zen"},//
    { id: 8 , label: "Scandinavian Art", value: "scandinavian"},//
    { id: 9 , label: "Expressionist Art", value: "expressionist"},
    { id: 10 , label: "Minimalistic Art", value: "minimalistic"},//
    { id: 11 , label: "Madhubani Art", value: "madhubani"},//
    { id: 12 , label: "Brutalism Art", value: "brutalism"},//
]

export default productCategory